<template>
  <v-card class="rounded-xl">
    <v-card-title class="text-center d-flex">
      <v-spacer></v-spacer>
      <h4 class="text-overline">
        Vendas da Semana
      </h4>
      <v-spacer></v-spacer>
      <v-btn icon small @click="getData" :loading="loading">
        <v-icon small>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>
    
    <v-card-text>
      <bar-chart :dados="dados" height="300px"></bar-chart>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { ref, onMounted, onUnmounted, getCurrentInstance } from 'vue';
import BarChart from "@/components/graficos/BarChart";

const { proxy } = getCurrentInstance();
const $axios = proxy.$axios;

const dados = ref({});
const loading = ref(false);

onMounted(async () => {
  loading.value = false;
  await getData();
});

const getData = async () => {
  try {
    loading.value = true;
    const response = await $axios.get('/dashboard/grafico-vendas-semana');
    dados.value = response.data;
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

</script>

<style>
  .sublinhado {
    text-decoration: underline;
  }
</style>